import { ISubscription } from '~/src/features/full-buy/store/helpers/tariffTransformerHelpers';
import { TSubscription } from '~/src/features/full-buy/store/initialState';

export const selectSubscriptionPopup = (subscription: TSubscription | ISubscription) => {
    if ('fullDescription' in subscription) {
        return {
            displayImage: subscription?.images.desktop || '',
            description: subscription.fullDescriptionList,
            title: subscription?.title  || '',
            isOpen: true,
        };
    }
    return {
        displayImage: subscription?.imageForFullBuyWebp || '',
        description: subscription.fullDescriptionList,
        title: subscription?.title  || '',
        isOpen: true,
    };
};
